import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { DriverAddComponent } from "../driver-add/driver-add.component";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-driver-view",
  templateUrl: "./driver-view.component.html",
  styleUrls: ["./driver-view.component.css"],
})
export class DriverViewComponent implements OnInit {
  matDialogueEdit!: MatDialogRef<DriverAddComponent>;
  driverData: any;
  NotesData: any;
  truckName: any;
  reasons: boolean = true;
  token: any;
  driverType: any = "-1";
  driverNumber: any = -1;
  constructor(
    private matdialogref: MatDialogRef<DriverViewComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: TruckOwnerService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.driverData = this.data;
    if (this.driverData.driver_remarks == "") {
      this.reasons = false;
    }
  }

  close() {
    this.matdialogref.close({ status: "close" });
  }
  editDriver() {
    let matDialogueEdit = this.matDialog.open(DriverAddComponent, {
      data: this.driverData,
      width: "80vw",
      height: "80vh",
      autoFocus: false,
    });
    matDialogueEdit.afterClosed().subscribe((res) => {
      if (res.event == "Success") {
        this.close();
        this.driverGet();
      }
    });
  }
  driverGet() {
    this.services
      .getDriverList(this.token, this.driverType, this.driverNumber)
      .subscribe(
        (response: any) => {},
        (error) => {
          if (error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
}
